export enum CustomContentSources {
	CONNECT = 'CONNECT',
	FORGE = 'FORGE',
}
